function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { classnames, clamp, format } from '@okee-uikit/react-utils';
import { useLocale, usePrefixCls } from '@okee-uikit/react-config';
import { useNextMicro } from '@okee-uikit/react-hooks';
import { Left, Right } from '../../common/icons';
import { Input } from '../input';
export function PagerSimple(props) {
  var _props$showTotal = props.showTotal,
      showTotal = _props$showTotal === void 0 ? false : _props$showTotal,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$pageSize = props.pageSize,
      pageSize = _props$pageSize === void 0 ? 10 : _props$pageSize,
      renderTotal = props.renderTotal,
      _props$page = props.page,
      page = _props$page === void 0 ? 1 : _props$page,
      className = props.className,
      _props$size = props.size,
      size = _props$size === void 0 ? 'xs' : _props$size,
      _props$total = props.total,
      total = _props$total === void 0 ? 0 : _props$total,
      _props$showInput = props.showInput,
      showInput = _props$showInput === void 0 ? true : _props$showInput,
      onPageChange = props.onPageChange,
      style = props.style,
      flat = props.flat;
  var pageCount = Math.ceil(total / pageSize);
  var autoPage = Math.min(page, pageCount);

  var _useState = useState("".concat(autoPage)),
      _useState2 = _slicedToArray(_useState, 2),
      simpleInputValue = _useState2[0],
      setSimpleInputValue = _useState2[1];

  var localeTotal = useLocale('pager.total');
  useEffect(function () {
    if ("".concat(autoPage) !== simpleInputValue) {
      setSimpleInputValue("".concat(autoPage));
    }
  }, [autoPage]);

  var setCurrentIndex = function setCurrentIndex(index) {
    onPageChange && onPageChange(index);
  };

  var onInputEntry = useCallback(function () {
    var val = Number.parseInt(simpleInputValue, 10);

    if (disabled || Number.isNaN(val)) {
      setSimpleInputValue("".concat(page));
      return;
    }

    var finalVal = clamp(val, 1, pageCount);
    setCurrentIndex(finalVal);
    setSimpleInputValue("".concat(finalVal));
  }, [simpleInputValue, disabled, page, pageCount]);
  var onInputBlur = useNextMicro(onInputEntry);

  var onSimpleInputChange = function onSimpleInputChange(value) {
    setSimpleInputValue(value);
  };

  var setPageIndex = function setPageIndex(variable) {
    var result = page + variable;

    if (result <= 0 || result > pageCount || disabled) {
      return;
    }

    setSimpleInputValue("".concat(result));
    setCurrentIndex(result);
  };

  var simpleCls = classnames(usePrefixCls('pager', {
    size: size,
    disabled: disabled
  }), usePrefixCls('pager-simple', {
    compact: !showInput
  }), className);
  var recordCls = usePrefixCls('pager-record');
  var turnAreaCls = usePrefixCls('pager-turn-area', {
    flat: flat
  });
  var turnInputCls = usePrefixCls('pager-turn-input');
  var turnCountCls = usePrefixCls('pager-turn-count');
  var turnArrowCls = usePrefixCls('pager-turn-arrow', {
    flat: flat
  });

  var getTotal = function getTotal() {
    if (!showTotal) {
      return React.createElement(Fragment, null);
    }

    return React.createElement("span", {
      className: recordCls
    }, typeof renderTotal === 'function' ? renderTotal(total) : format(localeTotal, {
      total: total
    }));
  };

  return React.createElement("div", {
    className: simpleCls,
    style: style
  }, getTotal(), React.createElement("span", {
    className: classnames(turnArrowCls, usePrefixCls('pager-turn-arrow-prev'), {
      'disabled-arrow': page <= 1 || disabled
    }),
    onClick: function onClick() {
      return setPageIndex(-1);
    }
  }, React.createElement(Left, null)), React.createElement("span", {
    className: turnAreaCls
  }, showInput ? React.createElement(Input, {
    size: size,
    disabled: disabled,
    className: turnInputCls,
    onValueChange: onSimpleInputChange,
    onPressEnter: onInputEntry,
    onBlur: onInputBlur,
    inputStyle: {
      textAlign: 'center'
    },
    placeholder: "",
    value: simpleInputValue
  }) : React.createElement("span", {
    className: turnCountCls
  }, simpleInputValue), !flat && React.createElement(Fragment, null, React.createElement("span", null, "/"), React.createElement("span", {
    className: turnCountCls
  }, pageCount))), React.createElement("span", {
    className: classnames(turnArrowCls, usePrefixCls('pager-turn-arrow-next'), {
      'disabled-arrow': page === pageCount || disabled
    }),
    onClick: function onClick() {
      return setPageIndex(1);
    }
  }, React.createElement(Right, null)));
}